import styled from 'styled-components';
import BulletIcon from '../../components/ui/BulletIcon';
import KIAImage from '../ui/image/KIAImage';

const CompanyOfferStyled = styled.section`
  display: flex;
  flex-direction: row;
  gap: 0;

  > img {
    width: 31%;
    height: auto;
    object-fit: cover;
  }

  > .content {
    display: flex;
    flex-direction: column;
    background-color: #f4f4f4;
    width: 100%;
    padding: 26px 16px 0 32px;
  }

  > .content > h2 {
    max-width: 700px;
    letter-spacing: -1.56px;
  }

  /* paragraph version */
  > .content > p {
    font-size: 14px;
    line-height: 20px;
    max-width: 690px;
  }

  /* list version */
  > .content > ul {
    list-style: none; /* we insert our own bullets */
    padding: 0;
    margin: 0;
  }

  > .content > ul li {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 14px;
    line-height: 20px;
    max-width: 690px;
    margin-bottom: 6px;
  }

  > .content > span.legal-text {
    font-size: 9px;
    line-height: 18px;
    color: #5f5f5f;
    margin-top: 4px;
  }

  @media screen and (max-width: 940px) {
    flex-direction: column;

    > .content {
      padding: 14px 16px 0 16px;
    }

    > .content > h2 {
      max-width: 85%;
      letter-spacing: 0.5px;
    }

    > .content > p,
    > .content > ul li {
      line-height: 22px !important;
    }

    > img {
      width: 100%;
    }
  }

  .link-button {
    background-color: #000;
    color: #fff;
    line-height: 24px;
    font-size: 20px;
    padding: 16px 58px;
    margin: auto 4px 17px auto;

    @media screen and (max-width: 940px) {
      margin: 34px auto 40px auto;
      padding: 14px 50px;
    }
  }
`;

interface Props {
  image: string;
  title?: string;
  subTitle: string;
  text?: string;
  listItems?: readonly string[];
  legalText?: string;
  link: string;
  linkText: string;
}

const CompanyOffer = ({
  image,
  title,
  subTitle,
  text,
  listItems,
  legalText,
  link,
  linkText,
}: Props) => {
  return (
    <CompanyOfferStyled className="px-4 mx-auto max-w-7xl">
      <KIAImage
        sizes="(max-width: 768px) 100vw, 290px"
        alt={title || 'Company offer'}
        src={image}
        className="aspect-video object-[50%_60%]"
      />

      <div className="content">
        {title && <h2>{title}</h2>}
        {subTitle && <h3 className="mb-2">{subTitle}</h3>}

        {text && <p className="mb-2 text-lg ">{text}</p>}
        {listItems && listItems.length > 0 && (
          <ul>
            {listItems.map((item, i) => (
              <li key={i} className="flex items-start space-x-2">
                <BulletIcon className="w-[6px] h-[6px] mt-[7px] flex-shrink-0" />

                <span>{item}</span>
              </li>
            ))}
          </ul>
        )}

        {legalText && <span className="legal-text">{legalText}</span>}

        <a className="no-underline link-button text-white" href={link}>
          {linkText}
        </a>
      </div>
    </CompanyOfferStyled>
  );
};

export default CompanyOffer;
